export const assignToItemTemplate = (option) => {
  if (option?.res_type === 'user' && option?.is_confirmed === false && option?.status === 'ACTIVE') {
    return (
      <>
        {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {`${option?.label} (Unconfirmed)`}
      </>
    );
  } else if (
    (option?.res_type === 'user' && option?.is_confirmed === false && option?.status === 'ARCHIVED') ||
    (option?.res_type === 'user-group' && option?.status === 'ARCHIVED') ||
    (option?.res_type === 'user' && option?.is_confirmed && option?.status === 'ARCHIVED')
  ) {
    return (
      <>
        {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {`${option?.label} (Inactive)`}
      </>
    );
  }

  return (
    <>
      {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
      {option?.label}
    </>
  );
};
